import loadable from '@loadable/component';

export { default as FavouriteListing } from './FavouriteListing';
export { isListingFavourite, getFavouriteListingIds } from './favouriteUtils';
export { default as translations } from './translations.json';

// Lazy-loaded page component
export const FavouriteListingsPage = loadable(() =>
  import(/* webpackChunkName: "FavouriteListingsPage" */ './FavouriteListingsPage')
);

// RTK Query APIs — needed for middleware and reducer registration
export { UserApi } from './UserApi';
export { FavouriteListingsApi } from './FavouriteListingsApi';
